import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  displayName = Layout.name
    constructor(props) {
        super(props);
        this.getCookie = this.getCookie.bind(this);     
    }
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    render() {
        var localCookie = this.getCookie('liferu');
        var menu = localCookie === "statanlylife2021" ? <NavMenu /> : <div></div>;       
    return (
      <Grid fluid>
        <Row>
          <Col sm={3}>
             {menu}
          </Col>
          <Col sm={9}>
            {this.props.children}
          </Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js